import * as React from 'react';
import { Store } from 'redux';
import { IndexRedirect, Route } from 'react-router';
import { makeGetComponent } from './utils';

export const getChannelRoute = (store: Store<RootState>) => (
  <Route
    path="channel/:channelId"
    getComponent={makeGetComponent('ChannelPage')}
  >
    <IndexRedirect to="messages" />
    <Route
      path="broadcast"
      getComponent={makeGetComponent('ChannelBroadcast')}
    />
    <Route
      path="followers"
      getComponent={makeGetComponent('ChannelFollowers')}
    />
    <Route path="messages" getComponent={makeGetComponent('ChannelMessages')} />
    <Route path="folder" getComponent={makeGetComponent('ChannelFolder')} />
    <Route path="shop" getComponent={makeGetComponent('ChannelShop')} />
    <Route path="data" getComponent={makeGetComponent('ChannelDataPrice')} />
    <Route path="settings" getComponent={makeGetComponent('ChannelSettings')} />
    <Route path="trades" getComponent={makeGetComponent('ChannelTrades')} />
    <Route
      path="trades/:tradeId"
      getComponent={makeGetComponent('TradeDetails')}
    />
  </Route>
);



// WEBPACK FOOTER //
// ./app/routers/ChannelRoute.tsx